export enum MAP_ACTION_TYPE {
    POLYGON_UPDATE_POINTS = 'POLYGON_UPDATE_POINTS',
    CIRCLE_UPDATE_POINTS = 'CIRCLE_UPDATE_POINTS'
}
